import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { queryKeys } from '../constants';
import { DashboardModel } from '../models';

export function useGetDashboards(disabled?: boolean) {
  return useQuery<DashboardModel[]>({
    queryKey: [queryKeys.DASHBOARD],
    queryFn: async () => {
      const res = await $api.get('/v1/dashboard');

      return res?.data?.data;
    },
    retry: false,
    enabled: !disabled,
    onError: baseErrorHandler,
    refetchOnWindowFocus: false
  });
}
